import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
	return localStorage.getItem('companyId')
}

export async function getAllData() {
	const companyId = getCompanyId()
	const { data, error } = await supabase.from('counselorcornerview').select().eq('companyId', companyId)

	if (error) {
		throw new Error('Failed to fetch data')
	}
	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('counselorcorner').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}
	return data
}

export async function getStudentIdData(id) {
	const companyId = getCompanyId()
	const prm = `studentId.eq.${id},studentId.is.null`

	const { data, error } = await supabase.from('counselorcorner').select().eq('companyId', companyId).or(prm)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getInstructorStudent(id) {
	const { data, error } = await supabase.from('counselorcorner').select().or(`instructorId.eq.${id},subinstructorId.eq.${id}`)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('counselorcorner').insert(adata).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	console.log('udata', udata)
	const { data, error } = await supabase.from('counselorcorner').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('counselorcorner').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
